import React from 'react';
import { Box, Chip } from '@mui/material';
import { BreathingSparkAnimation } from 'components/Animations';

export type BoardWorkingPillProps = {
  isVisible: boolean;
};

const BoardWorkingPill: React.FC<BoardWorkingPillProps> = ({ isVisible }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Box sx={{ marginBottom: 0.5 }}>
      <Chip
        label={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <BreathingSparkAnimation height={20} width={20} />
            </Box>
            <Box
              sx={{
                fontSize: '16px',
                fontWeight: 400,
                color: 'var(--color-text-secondary, rgba(0, 0, 0, 0.6))',
                position: 'relative',
                overflow: 'hidden',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: '-100%',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(90deg, transparent 20%, rgba(255,255,255,0.7) 50%, transparent 80%)',
                  animation: 'shimmer 2s infinite ease-in-out',
                },
                '@keyframes shimmer': {
                  '0%': {
                    left: '-100%',
                  },
                  '100%': {
                    left: '100%',
                  },
                },
              }}
            >
              Working...
            </Box>
          </Box>
        }
        size="small"
        sx={{
          backgroundColor: 'var(--color-grey-50)',
          borderRadius: '16px',
          height: '32px',
          '& .MuiChip-label': {
            padding: '0 12px 0 4px',
          },
        }}
      />
    </Box>
  );
};

export default BoardWorkingPill; 